<template>
  <div class="empty-container">
    <div class="empty-title">信息更新中 敬请期待</div>
    <div class="empty-tips">先去其他城市看看吧~</div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {},
  data() {
    return {}
  },
  methods: {},
}
</script>
<style lang="less">
.empty-container {
  margin: 17rem auto;
  text-align: center;
  font-family: HYYakuHei55W;
  color: #330ad6;
  .empty-title {
    display: inline-block;
    margin-bottom: 2.5rem;
    text-align: center;
    font-weight: 850;
    font-size: 3.6rem;
    padding: 3.5rem 7rem;
    background: linear-gradient(to bottom right, #f0fcff, #6ae1fd);
    border: 0.2rem solid #330ad6;
    box-shadow: 1rem -1rem #330ad6;
  }
  .empty-tips {
    font-size: 2.2rem;
    line-height: 3.7rem;
  }
}
</style>
